import dayjs from 'dayjs';
import { WTS_MOMENT_DATE_MASK } from 'src/constants/dayjs';
class CalendarShiftsParser {
    parseUsersPeriods(users) {
        return users.map((user) => ({
            ...user,
            Jobs: this.parseMonthByShifts(user.Jobs)
        }));
    }
    parseMonthByShifts(monthEvents) {
        return Object.keys(monthEvents)
            .reduce((counter, key) => ({
            ...counter,
            [key]: this.compareEventsToShifts(monthEvents[key])
        }), {});
    }
    compareEventsToShifts(dayData, sortShifts = false) {
        const { Planned, Worked, Calculated } = dayData;
        if (!Planned.length && !Worked.length && !Calculated.length)
            return [];
        const shifts = this.defineShifts(dayData);
        const dayDataKeys = ['Planned', 'Worked', 'Calculated'];
        dayDataKeys.forEach((groupKey) => {
            const groupData = dayData[groupKey];
            groupData.forEach((event) => {
                const relatedShift = shifts.find((shift) => this.checkIntersectsShift(event.Period, shift.Period));
                relatedShift?.[groupKey].push(event);
            });
        });
        if (sortShifts)
            shifts.sort((a, b) => dayjs(a.Period.StartDate).diff(dayjs(b.Period.StartDate)));
        return shifts.map((shift) => ({
            ...this.getShiftLimits(shift),
            Period: dayData.Period
        }));
    }
    defineShifts(dayData) {
        const { Planned, Worked, Calculated } = dayData;
        const groupData = [...Planned, ...Worked, ...Calculated];
        const sortedEvents = groupData.sort((a, b) => {
            if (a.IsLeave && !b.IsLeave)
                return -Infinity;
            else if (!a.IsLeave && b.IsLeave)
                return Infinity;
            return dayjs(a.Period.StartDate).diff(dayjs(b.Period.StartDate));
        });
        const shifts = [];
        sortedEvents.some((event) => {
            const currentShift = shifts[shifts.length - 1];
            const eventEnd = event.Period.EndDate;
            const shiftEnd = currentShift?.Period?.EndDate;
            if (event.IsLeave) {
                this.fixLeaveEventPeriod(event);
                shifts.push(this.getShiftInitials(event.Period));
                return true;
            }
            else if (!shifts.length) {
                shifts.push(this.getShiftInitials(event.Period));
            }
            else if (this.checkIntersectsShift(event.Period, currentShift.Period)) {
                if (eventEnd > shiftEnd) {
                    currentShift.Period.EndDate = eventEnd;
                }
            }
            else {
                shifts.push(this.getShiftInitials(event.Period));
            }
            return false;
        });
        return shifts;
    }
    fixLeaveEventPeriod(event) {
        const date = event.Period.StartDate.split('T')[0];
        event.Period = {
            StartDate: `${date}T00:00:00`,
            EndDate: `${date}T23:59:59`
        };
    }
    checkIntersectsShift(eventPeriod, shiftPeriod) {
        const { StartDate, EndDate } = eventPeriod;
        const minBorder = dayjs(shiftPeriod.StartDate).subtract(1, 'h');
        const maxBorder = dayjs(shiftPeriod.EndDate).add(1, 'h');
        const start = dayjs(StartDate);
        const end = dayjs(EndDate);
        return start.isBetween(minBorder, maxBorder, 'minutes', '[)')
            || end.isBetween(minBorder, maxBorder, 'minutes', '(]')
            || (start.isBefore(minBorder) && end.isAfter(maxBorder))
            || (start.isAfter(minBorder) && end.isBefore(maxBorder));
    }
    getShiftInitials(period) {
        return {
            Period: {
                StartDate: period.StartDate,
                EndDate: period.EndDate || dayjs().format(WTS_MOMENT_DATE_MASK)
            },
            Planned: [],
            Worked: [],
            Calculated: []
        };
    }
    getShiftLimits(shift) {
        const { Planned, Worked } = shift;
        return ({
            ...shift,
            WorkedLimits: {
                StartDate: Worked.length ? this.getWorkedMinDate(Worked) : null,
                EndDate: Worked.length ? this.getWorkedMaxDate(Worked) : null
            },
            PlannedLimits: {
                StartDate: Planned.length ? this.getMinDate(Planned) : null,
                EndDate: Planned.length ? this.getMaxDate(Planned) : null
            },
            ShiftLimits: {
                StartDate: Worked.length || Planned.length ? this.getMinDate([...Planned, ...Worked]) : null,
                EndDate: Worked.length || Planned.length ? this.getMaxDate([...Planned, ...Worked]) : null
            }
        });
    }
    getMinDate(events) {
        return events.reduce((minDate, { Period }) => (dayjs(Period.StartDate).isBefore(minDate)
            ? Period.StartDate
            : minDate), events[0].Period.StartDate);
    }
    getMaxDate(events) {
        return events.reduce((maxDate, { Period }) => {
            const { EndDate } = Period;
            const endDate = EndDate ? dayjs(EndDate) : dayjs();
            return endDate.isAfter(maxDate) ? EndDate : maxDate;
        }, events[0].Period.StartDate);
    }
    getWorkedMinDate(events) {
        return events.reduce((minDate, { Job: { Period } }) => (dayjs(Period.StartDate).isBefore(minDate)
            ? Period.StartDate : minDate), events[0].Period.StartDate);
    }
    getWorkedMaxDate(events) {
        return events.reduce((maxDate, { Job: { Period } }) => {
            const { EndDate } = Period;
            const endDate = EndDate ? dayjs(EndDate) : dayjs();
            return endDate.isAfter(maxDate) ? EndDate : maxDate;
        }, events[0].Period.StartDate);
    }
}
export const shiftsParser = new CalendarShiftsParser();
